export enum DrawerModeType {
	OVER = 'over',
	PUSH = 'push',
	SIDE = 'side',
}
